// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const Environment = {
  Local: {
    production: false,
    /**
     * GraphQL server Endpoint URL
     */
    PropertyAdminGQLHost: "http://localhost:5122/propertyxadmin",
    Property365CrmApiHost: "https://demop365api.property365.my",
    GoogleApiKey: "AIzaSyAjLHpeTRaaHTL1dZ5NEHIQ42ADxvVVGHE",
    DisableLoader: true,
    DateFormat: "DD MMM YYYY, hh:mm:A",
    InputDateFormat: "DD/MM/YYYY",
    InputDateTimeFormat: "DD/MM/YYYY HH:mm:ss",
    AzureClientId: 'fe42e02d-975d-413f-a7db-8893e3c4ff23',
    AzureTenantId: 'ca41deb8-f59b-4135-b83a-0fa73403ce81',
    AzureRedirect:  'http://localhost:4200/project-setting/project-list',
    AzureLogoutRedirect: 'http://localhost:4200/authentication/login',
    tinyMceApiKey: 'o0o3jt3p012xq8n7jtkzis20ihi3ugxc7ilgbwyd4evfnmat',
    PasswordPublicKey: `
    -----BEGIN PUBLIC KEY-----
    MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCYew+xTQWimCKAaLKuVXEptqcL
    d+jF8046lyrn8Ow8+fCuWZlLnrdeAcjMyyFsQ+PS6nJnPTGtXFiEdUQ9elPPqYrx
    xnMS4pZxDuuq75Y9hEL4HsYON1+5gVQNJuv/xhGxXq6nmjE5aSOeMQq1fcralcdK
    P90sJSdGAZpiNNYSLwIDAQAB
    -----END PUBLIC KEY-----`,
  },
  Dev: {
    production: false,
    /**
     * GraphQL server Endpoint URL
     */
    PropertyAdminGQLHost: "https://admin-api-indo-dev.ifca.io/propertyxadmin",
    Property365CrmApiHost: "https://demop365api.property365.my",
    GoogleApiKey: "AIzaSyAjLHpeTRaaHTL1dZ5NEHIQ42ADxvVVGHE",
    DisableLoader: false,
    DateFormat: "DD MMM YYYY, hh:mm:A",
    InputDateFormat: "DD/MM/YYYY",
    InputDateTimeFormat: "DD/MM/YYYY HH:mm:ss",
    tinyMceApiKey: 'o0o3jt3p012xq8n7jtkzis20ihi3ugxc7ilgbwyd4evfnmat',
    AzureClientId: 'fe42e02d-975d-413f-a7db-8893e3c4ff23',
    AzureTenantId: 'ca41deb8-f59b-4135-b83a-0fa73403ce81',
    AzureRedirect:  'https://admin-indo-dev.ifca.io/project-setting/project-list',
    AzureLogoutRedirect: 'https://admin-indo-dev.ifca.io/authentication/login',
    PasswordPublicKey: `
    -----BEGIN PUBLIC KEY-----
    MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCYew+xTQWimCKAaLKuVXEptqcL
    d+jF8046lyrn8Ow8+fCuWZlLnrdeAcjMyyFsQ+PS6nJnPTGtXFiEdUQ9elPPqYrx
    xnMS4pZxDuuq75Y9hEL4HsYON1+5gVQNJuv/xhGxXq6nmjE5aSOeMQq1fcralcdK
    P90sJSdGAZpiNNYSLwIDAQAB
    -----END PUBLIC KEY-----`,
  },
  Uat: {
    production: false,
    /**
     * GraphQL server Endpoint URL
     */
    PropertyAdminGQLHost: "https://admin-indo-api-dev.ifca.io/propertyxadmin",
    Property365CrmApiHost: "https://demop365api.property365.my",
    GoogleApiKey: "AIzaSyAjLHpeTRaaHTL1dZ5NEHIQ42ADxvVVGHE",
    DisableLoader: false,
    DateFormat: "DD MMM YYYY, hh:mm:A",
    InputDateFormat: "DD/MM/YYYY",
    InputDateTimeFormat: "DD/MM/YYYY HH:mm:ss",
    tinyMceApiKey: 'o0o3jt3p012xq8n7jtkzis20ihi3ugxc7ilgbwyd4evfnmat',
    AzureClientId: 'fe42e02d-975d-413f-a7db-8893e3c4ff23',
    AzureTenantId: 'ca41deb8-f59b-4135-b83a-0fa73403ce81',
    AzureRedirect:  'https://admin-indo-demo.ifca.io/project-setting/project-list',
    AzureLogoutRedirect: 'https://admin-indo-demo.ifca.io/authentication/login',
    PasswordPublicKey: `
    -----BEGIN PUBLIC KEY-----
    MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCYew+xTQWimCKAaLKuVXEptqcL
    d+jF8046lyrn8Ow8+fCuWZlLnrdeAcjMyyFsQ+PS6nJnPTGtXFiEdUQ9elPPqYrx
    xnMS4pZxDuuq75Y9hEL4HsYON1+5gVQNJuv/xhGxXq6nmjE5aSOeMQq1fcralcdK
    P90sJSdGAZpiNNYSLwIDAQAB
    -----END PUBLIC KEY-----`,
  },
  Prod: {
    production: false,
    /**
     * GraphQL server Endpoint URL
     */
    PropertyAdminGQLHost: "https://admin-api.property-x.asia/propertyxadmin",
    Property365CrmApiHost: "https://p365api.property365.my",
    GoogleApiKey: "AIzaSyAjLHpeTRaaHTL1dZ5NEHIQ42ADxvVVGHE",
    DisableLoader: false,
    DateFormat: "DD MMM YYYY, hh:mm:A",
    InputDateFormat: "DD/MM/YYYY",
    InputDateTimeFormat: "DD/MM/YYYY HH:mm:ss",
    tinyMceApiKey: 'o0o3jt3p012xq8n7jtkzis20ihi3ugxc7ilgbwyd4evfnmat',
    PasswordPublicKey: `
    -----BEGIN PUBLIC KEY-----
    MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCYew+xTQWimCKAaLKuVXEptqcL
    d+jF8046lyrn8Ow8+fCuWZlLnrdeAcjMyyFsQ+PS6nJnPTGtXFiEdUQ9elPPqYrx
    xnMS4pZxDuuq75Y9hEL4HsYON1+5gVQNJuv/xhGxXq6nmjE5aSOeMQq1fcralcdK
    P90sJSdGAZpiNNYSLwIDAQAB
    -----END PUBLIC KEY-----`,
  },
};

export const environment = Environment.Dev;
